// Artop UI upgrades
(function(){
  // 1. Scroll progress bar
  const updateScroll = () => {
    const h = document.documentElement;
    const pct = Math.min(100, (h.scrollTop / (h.scrollHeight - h.clientHeight) * 100) || 0);
    document.body.style.setProperty('--artop-scroll', pct + '%');
  };
  window.addEventListener('scroll', updateScroll, { passive: true });
  updateScroll();

  // 2. Section reveal on scroll
  const sections = document.querySelectorAll('main > section, main > .shopify-section > section');
  if (sections.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('is-visible'); obs.unobserve(e.target); } });
    }, { threshold: 0.08 });
    sections.forEach(s => { if (!s.hasAttribute('data-artop-reveal')) s.setAttribute('data-artop-reveal', ''); obs.observe(s); });
  }

  // 3. Subtle add-to-cart feedback (no content replace, just CSS class)
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches('form[action*="/cart/add"], product-form form')) return;
    const btn = f.querySelector('button[type="submit"], button[name="add"]');
    if (!btn) return;
    btn.classList.add('artop-btn-pulse');
    setTimeout(() => btn.classList.remove('artop-btn-pulse'), 1200);
  }, true);
})();
